export const DAILY_QUESTS = [

	{
		id: "responder_10",
		titulo: "Entrenamiento Diario",
		descripcion:
			"Responde 10 preguntas",

		objetivo: 10,

		recompensaXp: 50,

		tipo: "preguntas"
	},

	{
		id: "racha_5",
		titulo: "Modo En Llamas",
		descripcion:
			"Consigue una racha de 5",

		objetivo: 5,

		recompensaXp: 80,

		tipo: "streak"
	},

	{
		id: "ganar_100_xp",
		titulo: "Farm de XP",
		descripcion:
			"Gana 100 XP",

		objetivo: 100,

		recompensaXp: 120,

		tipo: "xp"
	}
];